/* (ignored) */


//////////////////
// WEBPACK FOOTER
// util (ignored)
// module id = 1
// module chunks = main polyfills